import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "button-warning" }
const _hoisted_2 = { class: "error-msg" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "optional-btn-label" }
const _hoisted_6 = { class: "optional-btn-label" }
const _hoisted_7 = { class: "optional-btn-label" }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  key: 4,
  class: "table table-sm"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 5,
  class: "table table-sm"
}
const _hoisted_15 = { class: "thead thead-dark" }
const _hoisted_16 = {
  class: "table-primary",
  style: {"font-weight":"bold"}
}
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = {
  key: 0,
  class: "text-success"
}
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = ["title", "onClick"]
const _hoisted_21 = ["title"]
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  class: "text-success"
}
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 7 }
const _hoisted_32 = { class: "optional-btn-label" }
const _hoisted_33 = {
  key: 0,
  class: "table table-sm"
}
const _hoisted_34 = { class: "thead thead-dark" }
const _hoisted_35 = ["title"]
const _hoisted_36 = ["title"]
const _hoisted_37 = ["title"]
const _hoisted_38 = {
  key: 1,
  class: "status-badge status-badge-success",
  title: "A later retry succeeded for this data"
}
const _hoisted_39 = {
  key: 2,
  class: "status-badge status-badge-warning",
  title: "Will be automatically retried"
}
const _hoisted_40 = {
  key: 3,
  class: "status-badge status-badge-muted",
  title: "Will not be automatically retried"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "optional-btn-label" }
const _hoisted_44 = {
  class: "modal",
  id: "run_logs_modal",
  tabindex: "-1",
  role: "dialog",
  "aria-hidden": "true"
}
const _hoisted_45 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_46 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_47 = { class: "modal-header" }
const _hoisted_48 = { class: "modal-title" }
const _hoisted_49 = {
  class: "modal-body",
  id: "rule_config_modal_body"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_53 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_PrettifyJSON = _resolveComponent("PrettifyJSON")!
  const _component_tasks_config_modal = _resolveComponent("tasks-config-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.errorMsg), 1)
    ], 512), [
      [_vShow, _ctx.errorMsg.length > 0]
    ]),
    _createElementVNode("div", null, [
      _cache[48] || (_cache[48] = _createElementVNode("h1", { title: "These dictate which automatic analysis tasks are run on incoming data" }, "Task Rules", -1)),
      (_ctx.task_rules_loading || _ctx.task_runs_loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Loading..."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.task_rules.length == 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "There are no task rules configured on this platform."))
              : _createCommentVNode("", true),
            (!_ctx.show_stats && _ctx.task_rules.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show_stats = true)),
                  title: "show stats",
                  style: {"margin":"1em"}
                }, [
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_vue_feather, {
                      type: "bar-chart",
                      size: "16"
                    }),
                    _cache[20] || (_cache[20] = _createTextVNode(" Show stats ", -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.show_stats && _ctx.task_rules.length > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "btn btn-warning",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.show_stats = false)),
                  title: "show config",
                  style: {"margin":"1em"}
                }, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_vue_feather, {
                      type: "settings",
                      size: "16"
                    }),
                    _cache[21] || (_cache[21] = _createTextVNode(" Show config ", -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showNewRule())),
              title: "new rule",
              style: {"margin":"1em"}
            }, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_vue_feather, {
                  type: "plus-square",
                  size: "16"
                }),
                _cache[22] || (_cache[22] = _createTextVNode(" Add new rule ", -1))
              ])
            ]),
            (_ctx.show_stats && _ctx.task_rules.length > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Showing stats for the last " + _toDisplayString(_ctx.format_duration(_ctx.history_length)) + ". ", 1))
              : _createCommentVNode("", true),
            (!_ctx.show_stats && _ctx.task_rules.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                  _cache[25] || (_cache[25] = _createElementVNode("thead", { class: "thead thead-dark" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { scope: "col" }, "Name"),
                      _createElementVNode("th", { scope: "col" }, "Task"),
                      _createElementVNode("th", { scope: "col" }, "Data Type"),
                      _createElementVNode("th", { scope: "col" }, "Parameters"),
                      _createElementVNode("th", { scope: "col" }, "Filters"),
                      _createElementVNode("th", { scope: "col" }, "Max Concurrent"),
                      _createElementVNode("th", { scope: "col" }, "Enabled"),
                      _createElementVNode("th", { scope: "col" })
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task_rules, (rule) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: rule.TaskRuleID,
                        class: _normalizeClass({ 'table-secondary': !rule.Enabled })
                      }, [
                        _createElementVNode("td", {
                          title: 'task_rules ID ' + rule.ID
                        }, _toDisplayString(rule.Name), 9, _hoisted_10),
                        _createElementVNode("td", {
                          title: 'task ID ' + rule.TaskID
                        }, _toDisplayString(rule.TaskName), 9, _hoisted_11),
                        _createElementVNode("td", null, _toDisplayString(rule.InputTable), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_PrettifyJSON, {
                            objectToPrettify: rule.Parameters
                          }, null, 8, ["objectToPrettify"])
                        ]),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(rule.StartTime ? " From " + _ctx.formatTime(rule.StartTime, false, false) : "") + " " + _toDisplayString(rule.EndTime ? " Until " + _ctx.formatTime(rule.EndTime, false, false) : "") + " " + _toDisplayString(rule.SensorIDs ? " Sensor IDs: " + rule.SensorIDs : "") + " ", 1),
                          (rule.SensorTags)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _cache[23] || (_cache[23] = _createTextVNode(" Sensor Tags: ", -1)),
                                _createVNode(_component_PrettifyJSON, {
                                  objectToPrettify: rule.SensorTags
                                }, null, 8, ["objectToPrettify"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(rule.MaxConcurrent ?? "Unlimited"), 1),
                        _createElementVNode("td", null, _toDisplayString(rule.Enabled ? "YES" : "NO"), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-outline-primary btn-sm",
                            onClick: ($event: any) => (_ctx.showConfigureRule(rule)),
                            title: "configure"
                          }, [
                            _createVNode(_component_vue_feather, {
                              type: "tool",
                              size: "12"
                            }),
                            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "optional-btn-label" }, "Configure", -1))
                          ], 8, _hoisted_13)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.show_stats && _ctx.task_rules.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                  _createElementVNode("thead", _hoisted_15, [
                    _createElementVNode("tr", null, [
                      _cache[26] || (_cache[26] = _createElementVNode("th", { scope: "col" }, "Name", -1)),
                      _cache[27] || (_cache[27] = _createElementVNode("th", { scope: "col" }, "Task", -1)),
                      _cache[28] || (_cache[28] = _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Queued", -1)),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "clickable text-center",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = { State: 'running' }))
                      }, "Running"),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "clickable text-success text-center",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = { Outcome: 'success' }))
                      }, " Successes "),
                      _createElementVNode("th", {
                        scope: "col",
                        class: "clickable text-danger text-center",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters = { Outcome: 'error' }))
                      }, " Failures "),
                      _cache[29] || (_cache[29] = _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Average Time", -1)),
                      _cache[30] || (_cache[30] = _createElementVNode("th", {
                        scope: "col",
                        class: "text-center"
                      }, "Slowest Time", -1)),
                      _cache[31] || (_cache[31] = _createElementVNode("th", { scope: "col" }, "Latest Runs", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_16, [
                      _createElementVNode("td", {
                        class: "clickable",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters = {}))
                      }, "All rules"),
                      _cache[32] || (_cache[32] = _createElementVNode("td", null, "---", -1)),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(Object.keys(_ctx.task_backlog_counts).reduce((a, b) => a + _ctx.task_backlog_counts[b], 0)), 1),
                      _createElementVNode("td", {
                        class: "clickable text-center",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.filters = { State: 'running' }))
                      }, _toDisplayString(_ctx.ruleStats.totals.running), 1),
                      _createElementVNode("td", {
                        class: "clickable text-success text-center",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.filters = { Outcome: 'success' }))
                      }, _toDisplayString(_ctx.ruleStats.totals.success), 1),
                      _createElementVNode("td", {
                        class: "clickable text-danger text-center",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.filters = { Outcome: 'error' }))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.ruleStats.totals.error) + " ", 1),
                        (_ctx.ruleStats.totals.resolvedFailures > 0)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_18, " (" + _toDisplayString(_ctx.ruleStats.totals.resolvedFailures) + " resolved) ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.format_duration(_ctx.ruleStats.totals.averageDuration)), 1),
                      _createElementVNode("td", {
                        class: "text-center clickable",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => {
                  _ctx.filters = {};
                  _ctx.sortBy('Duration');
                  _ctx.reverse = true;
                })
                      }, _toDisplayString(_ctx.format_duration(_ctx.ruleStats.totals.longestDuration)), 1),
                      _cache[33] || (_cache[33] = _createElementVNode("td", null, null, -1))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rulesWithStats, ({ rule, stats }) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: rule.TaskRuleID,
                        class: _normalizeClass({ 'table-secondary': !rule.Enabled })
                      }, [
                        _createElementVNode("td", {
                          class: "clickable",
                          title: 'task_rules ID ' + rule.TaskRuleID,
                          onClick: ($event: any) => (_ctx.filters = { RuleName: rule.Name })
                        }, _toDisplayString(rule.Name), 9, _hoisted_20),
                        _createElementVNode("td", {
                          title: 'task ID ' + rule.TaskID
                        }, _toDisplayString(rule.TaskName), 9, _hoisted_21),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.task_backlog_counts[rule.TaskRuleID]), 1),
                        _createElementVNode("td", {
                          class: "clickable text-center",
                          onClick: ($event: any) => (_ctx.filters = { RuleName: rule.Name, State: 'running' })
                        }, _toDisplayString(stats.running), 9, _hoisted_23),
                        _createElementVNode("td", {
                          class: "clickable text-success text-center",
                          onClick: ($event: any) => (_ctx.filters = { RuleName: rule.Name, Outcome: 'success' })
                        }, _toDisplayString(stats.success), 9, _hoisted_24),
                        _createElementVNode("td", {
                          class: "clickable text-danger text-center",
                          onClick: ($event: any) => (_ctx.filters = { RuleName: rule.Name, Outcome: 'error' })
                        }, [
                          _createTextVNode(_toDisplayString(stats.error) + " ", 1),
                          (stats.resolvedFailures > 0)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_26, " (" + _toDisplayString(stats.resolvedFailures) + " resolved) ", 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_25),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.format_duration(stats.averageDuration)), 1),
                        _createElementVNode("td", {
                          class: "clickable text-center",
                          onClick: ($event: any) => {
                  _ctx.filters = { RuleName: rule.Name };
                  _ctx.sortBy('Duration');
                  _ctx.reverse = true;
                }
                        }, _toDisplayString(_ctx.format_duration(stats.longestDuration)), 9, _hoisted_28),
                        _createElementVNode("td", {
                          class: "clickable",
                          onClick: ($event: any) => {
                  _ctx.filters = { RuleName: rule.Name };
                  _ctx.sortBy('StartedAt');
                  _ctx.reverse = true;
                }
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stats.latestOutcomes, (outcome, i) => {
                            return (_openBlock(), _createElementBlock("span", { key: i }, [
                              (outcome == 'success')
                                ? (_openBlock(), _createBlock(_component_vue_feather, {
                                    key: 0,
                                    class: "text-success",
                                    type: "check-circle",
                                    size: "16"
                                  }))
                                : (outcome == 'cancelled')
                                  ? (_openBlock(), _createBlock(_component_vue_feather, {
                                      key: 1,
                                      class: "text-warning",
                                      type: "x-square",
                                      size: "16"
                                    }))
                                  : (_openBlock(), _createBlock(_component_vue_feather, {
                                      key: 2,
                                      class: "text-danger",
                                      type: "alert-triangle",
                                      size: "16"
                                    }))
                            ]))
                          }), 128))
                        ], 8, _hoisted_29)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64)),
      _cache[49] || (_cache[49] = _createElementVNode("h1", { title: "These are instances of tasks running on particular data" }, "Task Runs", -1)),
      (_ctx.task_rules_loading || _ctx.task_runs_loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_30, "Loading..."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.filteredTaskRuns.length) + " ", 1),
              (_ctx.filters.RuleName)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" '" + _toDisplayString(_ctx.filters.RuleName) + "' ", 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.filteredTaskRuns.length == 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("task has ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode("tasks have ")
                  ], 64)),
              (_ctx.filters.Outcome == 'success')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode("succeeded")
                  ], 64))
                : (_ctx.filters.Outcome == 'error')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createTextVNode("failed")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _createTextVNode("started")
                    ], 64)),
              _createTextVNode(" in the last " + _toDisplayString(_ctx.format_duration(_ctx.history_length)) + " ", 1),
              (_ctx.filters.State == 'running')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _cache[34] || (_cache[34] = _createTextVNode("and ", -1)),
                    (_ctx.filteredTaskRuns.length == 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("is")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("are")
                        ], 64)),
                    _cache[35] || (_cache[35] = _createTextVNode(" still running", -1))
                  ], 64))
                : _createCommentVNode("", true),
              (Object.keys(_ctx.filters).length == 0 && _ctx.task_runs.length > 0)
                ? (_openBlock(), _createElementBlock("i", _hoisted_31, "- click on cells in the stats table above to filter this list."))
                : _createCommentVNode("", true),
              (Object.keys(_ctx.filters).length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 8,
                    type: "button",
                    class: "btn btn-light",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.filters = {})),
                    title: "clear filters"
                  }, [
                    _createElementVNode("span", _hoisted_32, [
                      _createVNode(_component_vue_feather, {
                        type: "filter",
                        size: "16"
                      }),
                      _cache[36] || (_cache[36] = _createTextVNode(" Clear filters ", -1))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.filteredTaskRuns.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_33, [
                  _createElementVNode("thead", _hoisted_34, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        scope: "col",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortBy('InputRow')))
                      }, [
                        (_ctx.sort_key != 'InputRow')
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 0,
                              type: "arrow-down",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'InputRow' && !_ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 1,
                              type: "arrow-down-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'InputRow' && _ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 2,
                              type: "arrow-up-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        _cache[37] || (_cache[37] = _createTextVNode(" Batch Number ", -1))
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sortBy('ruleName')))
                      }, [
                        (_ctx.sort_key != 'RuleName')
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 0,
                              type: "arrow-down",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'RuleName' && !_ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 1,
                              type: "arrow-down-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'RuleName' && _ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 2,
                              type: "arrow-up-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        _cache[38] || (_cache[38] = _createTextVNode(" Rule ", -1))
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sortBy('TaskName')))
                      }, [
                        (_ctx.sort_key != 'TaskName')
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 0,
                              type: "arrow-down",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'TaskName' && !_ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 1,
                              type: "arrow-down-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'TaskName' && _ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 2,
                              type: "arrow-up-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        _cache[39] || (_cache[39] = _createTextVNode(" Task ", -1))
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sortBy('Sensor')))
                      }, [
                        (_ctx.sort_key != 'Sensor')
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 0,
                              type: "arrow-down",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'Sensor' && !_ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 1,
                              type: "arrow-down-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'Sensor' && _ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 2,
                              type: "arrow-up-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        _cache[40] || (_cache[40] = _createTextVNode(" Sensor ", -1))
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sortBy('StartedAt')))
                      }, [
                        (_ctx.sort_key != 'StartedAt')
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 0,
                              type: "arrow-down",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'StartedAt' && !_ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 1,
                              type: "arrow-down-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'StartedAt' && _ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 2,
                              type: "arrow-up-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        _cache[41] || (_cache[41] = _createTextVNode(" Start Time ", -1))
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sortBy('Duration')))
                      }, [
                        (_ctx.sort_key != 'Duration')
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 0,
                              type: "arrow-down",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'Duration' && !_ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 1,
                              type: "arrow-down-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'Duration' && _ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 2,
                              type: "arrow-up-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        _cache[42] || (_cache[42] = _createTextVNode(" Duration ", -1))
                      ]),
                      _createElementVNode("th", {
                        scope: "col",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sortBy('Outcome'))),
                        style: {"min-width":"8em"}
                      }, [
                        (_ctx.sort_key != 'Outcome')
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 0,
                              type: "arrow-down",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'Outcome' && !_ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 1,
                              type: "arrow-down-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sort_key == 'Outcome' && _ctx.reverse)
                          ? (_openBlock(), _createBlock(_component_vue_feather, {
                              key: 2,
                              type: "arrow-up-circle",
                              size: "20px"
                            }))
                          : _createCommentVNode("", true),
                        _cache[43] || (_cache[43] = _createTextVNode(" Status ", -1))
                      ]),
                      _cache[44] || (_cache[44] = _createElementVNode("th", null, null, -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTaskRuns, (run) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: run.TaskRunID,
                        class: _normalizeClass({
                'table-danger': run.Outcome == 'error' && !_ctx.isResolvedFailure(run),
                'table-warning': run.Outcome == 'error' && _ctx.isResolvedFailure(run),
                'table-secondary': run.Outcome == 'cancelled',
                'table-success': run.Outcome == 'success',
              })
                      }, [
                        _createElementVNode("td", {
                          title: 'Input Row/Input Data' + run.TaskRunID
                        }, _toDisplayString(run.InputTable) + "/" + _toDisplayString(run.InputRow), 9, _hoisted_35),
                        _createElementVNode("td", {
                          title: 'run ID ' + run.TaskRunID
                        }, _toDisplayString(run.RuleName), 9, _hoisted_36),
                        _createElementVNode("td", null, _toDisplayString(run.TaskName), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(run.SensorName) + ": ", 1),
                          _createVNode(_component_PrettifyJSON, {
                            objectToPrettify: run.Sensor
                          }, null, 8, ["objectToPrettify"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatTime(run.StartedAt, false, true)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.format_duration(run.Duration)), 1),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(run.Outcome) + " ", 1),
                          (run.RetryCount > 0)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "status-badge status-badge-info",
                                title: 'Retry ' + run.RetryCount + ' of task run #' + run.RetryOfTaskRunID
                              }, " retry #" + _toDisplayString(run.RetryCount), 9, _hoisted_37))
                            : _createCommentVNode("", true),
                          (run.Outcome === 'error' && _ctx.isResolvedFailure(run))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, " resolved "))
                            : _createCommentVNode("", true),
                          (run.Outcome === 'error' && run.Retryable === true && !_ctx.isResolvedFailure(run))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, " retryable "))
                            : _createCommentVNode("", true),
                          (run.Outcome === 'error' && run.Retryable === false)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, " non-retryable "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          (run.HasLogs)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-primary btn-sm",
                                onClick: ($event: any) => (_ctx.showRunLogs(run)),
                                title: "logs"
                              }, [
                                _createVNode(_component_vue_feather, {
                                  type: "align-justify",
                                  size: "12"
                                }),
                                _cache[45] || (_cache[45] = _createElementVNode("span", { class: "optional-btn-label" }, "Logs", -1))
                              ], 8, _hoisted_41))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success btn-sm",
                            onClick: ($event: any) => (_ctx.rerun(run)),
                            title: "rerun"
                          }, [
                            _createElementVNode("span", _hoisted_43, [
                              _createVNode(_component_vue_feather, {
                                type: "repeat",
                                size: "12"
                              }),
                              _cache[46] || (_cache[46] = _createTextVNode(" Run again ", -1))
                            ])
                          ], 8, _hoisted_42)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64)),
      (_ctx.selected_rule)
        ? (_openBlock(), _createBlock(_component_tasks_config_modal, {
            key: 4,
            selected_rule: _ctx.selected_rule,
            sensorTagOptions: _ctx.sensor_tag_options,
            onClearSelectedRule: _ctx.onClearSelectedRule,
            onGetTaskRules: _ctx.getTaskRules,
            task_rules: _ctx.task_rules
          }, null, 8, ["selected_rule", "sensorTagOptions", "onClearSelectedRule", "onGetTaskRules", "task_rules"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          (_ctx.selected_run !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("h5", _hoisted_48, _toDisplayString(_ctx.selected_run.RuleName) + " / " + _toDisplayString(_ctx.selected_run.TaskName), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showRunLogsModal = !_ctx.showRunLogsModal))
                  }, [...(_cache[47] || (_cache[47] = [
                    _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
                  ]))])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  (_ctx.selected_run.RetryCount > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_50, [
                        _createElementVNode("strong", null, "Retry #" + _toDisplayString(_ctx.selected_run.RetryCount), 1),
                        _createTextVNode(" of task run #" + _toDisplayString(_ctx.selected_run.RetryOfTaskRunID), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.logs_loading)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_51, "Loading logs…"))
                    : (_ctx.logs_error)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(_ctx.logs_error), 1))
                      : (_openBlock(), _createElementBlock("pre", _hoisted_53, _toDisplayString(_ctx.selected_run.Logs), 1))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 512), [
        [_vShow, _ctx.showRunLogsModal]
      ])
    ])
  ]))
}